
import { createHelpers, getField, updateField } from 'vuex-map-fields'

const state = {
  info:
  {
    applyOtherReasonStr: '',
    applyReasonCode: '',
    appraiserOtherReasonStr: '',
    appraiserReason: '',
    appraiserReasonCode: '',
    approverStatus: '',
    // appraiserStaffCode: '',
    firstApproverEuid: null,
    firstApproverGroupId: null,
    birthday: '',
    // cantOfficialRecognizedLevelId: '',
    // cantSpeakLevelId: '',
    // cantWriteLevelId: '',
    careerId: '',
    careerType: '', // 1:一般職程; 2:領導主管
    categoryId: '',
    categoryScaleId: '',
    chinCategoryName: '', // specially handle
    chinCategoryScaleName: '', // specially handle
    chinEntityName: '', // specially handle
    chinName: '',
    chinSubunitEntityName: '', // specially handle
    chinVinculumTypeName: '', // specially handle
    companyTel: '',
    coordinatorOrder: '',
    coordinatorStatus: '',
    // educationLevelTypeId: '',
    // educationMajor: '',
    email: '',
    // engName : rootState.staff.info.engName
    // engOfficialRecognizedLevelId: '',
    // engSpeakLevelId: '',
    // engWriteLevelId: '',
    enterCareerDate: '', // careerType: 1: use categoryStartDate / 2: use officialTypeStartDate
    enterGovDate: '',
    entityId: '',
    euid: '',
    fax: '',
    // formCode : rootState.staff.info.formCode
    // formDate : rootState.staff.info.formDate
    // id : rootState.staff.info.id
    idCardNo: '',
    isDirectToCoordinator: false,
    jobDescription: '',
    // mandOfficialRecognizedLevelId: '',
    // mandSpeakLevelId: '',
    // mandWriteLevelId: '',
    mobile: '',
    // modifiedBy =
    // modifiedTime =
    // nativeLanguageId: '',
    officialTypeId: '',
    // otherNativeLanguageStr: '',
    portCategoryName: '', // specially handle
    portCategoryScaleName: '', // specially handle
    portEntityName: '', // specially handle
    portName: '',
    // portOfficialRecognizedLevelId: '',
    // portSpeakLevelId: '',
    portSubunitEntityName: '', // specially handle
    portVinculumTypeName: '', // specially handle
    // portWriteLevelId: '',
    proposalClassId: '',
    publishEntityId: '',
    sex: '',
    staffCode: '',
    // euid: '',
    status: '',
    subunitEntityId: '',
    // teachingLanguageId: '',
    vinculumTypeId: ''
    // isAgree: ''
  }
}

// actions
const actions = {
  initForm ({ commit, rootState }) {
    // g2eApi.getStaff(staff => {
    //   commit('setForm', staff)
    // })
    // commit('setForm', { staff: rootState.staff.info, appraiser: rootState.staff.appraiser })
    commit('setForm', rootState.staff.info)
  },

  clearForm ({ commit, rootState }) {
    // commit('clearForm', { staff: rootState.staff.info, appraiser: rootState.staff.appraiser })
    commit('clearForm', rootState.staff.info)
  },

  fillChinPortNames ({ commit, rootGetters }) {
    let category = null
    let categoryScale = null
    let subunitEntity = null
    let vinculumType = null

    if (state.info.categoryId) {
      category = rootGetters['codeTable/getCategoryById'](state.info.categoryId)
    }
    if (state.info.categoryScaleId) {
      categoryScale = rootGetters['codeTable/getCategoryScaleById'](state.info.categoryScaleId)
    }
    subunitEntity = rootGetters['codeTable/getSubunitEntityById'](state.info.subunitEntityId)
    vinculumType = rootGetters['codeTable/getVinculumTypeById'](state.info.vinculumTypeId)

    commit('setChinPortNames', { 'category': category, 'categoryScale': categoryScale, 'subunitEntity': subunitEntity, 'vinculumType': vinculumType })
  }

}

const getters = {
  getField
}

const mutations = {
  updateField,

  // Below mutation methods are for special case
  setCareerId (state, value) {
    state.info.careerId = value
  },
  setCategoryId (state, value) {
    state.info.categoryId = value
  },
  setFirstApproverEuid (state, value) {
    state.info.firstApproverEuid = value
  },
  setFirstApproverGroupId (state, value) {
    state.info.firstApproverGroupId = value
  },
  setIsDirectToCoordinator (state, value) {
    state.info.isDirectToCoordinator = value
  },
  // setMobile (state, value) {
  //   state.info.mobile = value
  // },
  // setCategoryScaleId (state, value) {
  //   state.info.categoryScaleId = value
  // },
  // setChinName (state, value) {
  //   state.info.chinName = value
  // },
  // setCompanyTel (state, value) {
  //   state.info.companyTel = value
  // },
  // setEmail (state, value) {
  //   state.info.email = value
  // },
  // setEnterCareerDate (state, value) {
  //   state.info.enterCareerDate = value
  // },
  // setEnterGovDate (state, value) {
  //   state.info.enterGovDate = value
  // },
  // setFax (state, value) {
  //   state.info.fax = value
  // },
  // setJobDescription (state, value) {
  //   state.info.jobDescription = value
  // },
  // setOfficialTypeId (state, value) {
  //   state.info.officialTypeId = value
  // },
  // setSubunitEntityId (state, value) {
  //   state.info.subunitEntityId = value
  // },
  // setVinculumTypeId (state, value) {
  //   state.info.vinculumTypeId = value
  // },
  // setIsAgree (state, value) {
  //   state.info.isAgree = value
  // },
  // setProposalClassId (state, value) {
  //   state.info.proposalClassId = value
  // },

  // setApplyReasonCode (state, value) {
  //   state.info.applyReasonCode = value
  // },
  // setCareerType (state, value) {
  //   state.info.careerType = value
  // },

  setForm (state, staff) {
    // state.info.birthday = new Date(cutTime(staff.birthDate))
    state.info.firstApproverEuid = staff.defaultNextEuid
    state.info.firstApproverGroupId = null
    state.info.birthday = staff.birthDate
    // state.info.cantOfficialRecognizedLevelId = staff.languages[0].officialRecognizedLevelId
    // state.info.cantSpeakLevelId = staff.languages[0].speakLevelId
    // state.info.cantWriteLevelId = staff.languages[0].writeLevelId
    state.info.careerId = staff.careerId
    state.info.categoryId = staff.categoryId
    state.info.categoryScaleId = staff.categoryScaleId
    state.info.chinName = staff.chinName
    if (staff.companyTel) {
      state.info.companyTel = staff.companyTel.replace(/\s/g, '') // clear white space
    }
    state.info.coordinatorOrder = staff.coordinatorOrder
    state.info.coordinatorStatus = staff.coordinatorStatus
    // state.info.educationLevelTypeId = staff.educations[0].educationLevelTypeId
    // state.info.educationMajor = staff.educations[0].eduTitle
    state.info.email = staff.email

    // state.info.engOfficialRecognizedLevelId = staff.languages[3].officialRecognizedLevelId
    // state.info.engSpeakLevelId = staff.languages[3].speakLevelId
    // state.info.engWriteLevelId = staff.languages[3].writeLevelId

    state.info.enterGovDate = staff.inGovDate
    state.info.entityId = staff.entityId
    state.info.euid = staff.euid
    state.info.chinEntityName = staff.entityChinName
    state.info.portEntityName = staff.entityPortName
    state.info.fax = staff.fax

    state.info.idCardNo = staff.docNum
    state.info.isDirectToCoordinator = false
    state.info.jobDescription = this._vm.$chPtObjData('jobAreaChinDesc', staff)
    // state.info.mandOfficialRecognizedLevelId = staff.languages[1].officialRecognizedLevelId
    // state.info.mandSpeakLevelId = staff.languages[1].speakLevelId
    // state.info.mandWriteLevelId = staff.languages[1].writeLevelId
    state.info.mobile = staff.mobile

    // for (let index = 0; index < staff.languages.length; index++) {
    //   if (staff.languages[index].isMotherLang) {
    //     state.info.nativeLanguageId = staff.languages[index].languageTypeId
    //     break
    //   }
    // }
    // state.ino.nativeLanguageId = nativeLangId
    state.info.officialTypeId = staff.officialTypeId
    // state.info.otherNativeLanguageStr = staff.otherNativeLanguageStr
    state.info.portName = staff.portName
    // state.info.portOfficialRecognizedLevelId = staff.languages[2].officialRecognizedLevelId
    // state.info.portSpeakLevelId = staff.languages[2].speakLevelId
    // state.info.portWriteLevelId = staff.languages[2].writeLevelId
    state.info.proposalClassId = staff.proposalClassId
    state.info.sex = staff.sexCode
    state.info.staffCode = staff.staffCode
    // state.info.euid = staff.euid
    state.info.subunitEntityId = staff.subunitId
    // state.info.teachingLanguageId = staff.educations[0].languageTypeId
    state.info.vinculumTypeId = staff.vinculumTypeId
    if (!staff.officialTypeId) {
      state.info.careerType = 1
    } else {
      state.info.careerType = 2
    }

    state.info.enterCareerDate = state.info.careerType === 1 ? staff.categoryStartDate : staff.officialTypeStartDate
  },

  clearForm (state, staff) {
    // state.info.birthday = new Date(cutTime(staff.birthDate))
    state.info.firstApproverEuid = staff.defaultNextEuid
    state.info.firstApproverGroupId = null
    // state.info.birthday = null
    // state.info.cantOfficialRecognizedLevelId = staff.languages[0].officialRecognizedLevelId
    // state.info.cantSpeakLevelId = staff.languages[0].speakLevelId
    // state.info.cantWriteLevelId = staff.languages[0].writeLevelId
    state.info.careerId = null
    state.info.categoryId = null
    state.info.categoryScaleId = null
    state.info.chinName = staff.chinName
    state.info.companyTel = null
    state.info.coordinatorOrder = null
    state.info.coordinatorStatus = null
    // state.info.educationLevelTypeId = staff.educations[0].educationLevelTypeId
    // state.info.educationMajor = staff.educations[0].eduTitle
    state.info.email = null

    // state.info.engOfficialRecognizedLevelId = staff.languages[3].officialRecognizedLevelId
    // state.info.engSpeakLevelId = staff.languages[3].speakLevelId
    // state.info.engWriteLevelId = staff.languages[3].writeLevelId
    state.info.enterCareerDate = null
    state.info.enterGovDate = null
    state.info.entityId = staff.entityId
    state.info.fax = null

    state.info.idCardNo = staff.docNum
    state.info.isDirectToCoordinator = false
    state.info.jobDescription = null
    // state.info.mandOfficialRecognizedLevelId = staff.languages[1].officialRecognizedLevelId
    // state.info.mandSpeakLevelId = staff.languages[1].speakLevelId
    // state.info.mandWriteLevelId = staff.languages[1].writeLevelId
    state.info.mobile = null

    // for (let index = 0; index < staff.languages.length; index++) {
    //   if (staff.languages[index].isMotherLang) {
    //     state.info.nativeLanguageId = staff.languages[index].languageTypeId
    //     break
    //   }
    // }
    // state.ino.nativeLanguageId = nativeLangId
    state.info.officialTypeId = null
    // state.info.otherNativeLanguageStr = staff.otherNativeLanguageStr
    state.info.portName = staff.portName
    // state.info.portOfficialRecognizedLevelId = staff.languages[2].officialRecognizedLevelId
    // state.info.portSpeakLevelId = staff.languages[2].speakLevelId
    // state.info.portWriteLevelId = staff.languages[2].writeLevelId
    state.info.proposalClassId = staff.proposalClassId
    state.info.sex = staff.sexCode
    state.info.staffCode = staff.staffCode
    state.info.euid = staff.euid

    state.info.subunitEntityId = null
    // state.info.teachingLanguageId = staff.educations[0].languageTypeId
    state.info.vinculumTypeId = null
    if (!staff.officialTypeId) {
      state.info.careerType = 1
    } else {
      state.info.careerType = 2
    }
  },

  setChinPortNames (state, payload) {
    if (payload.category) {
      state.info.chinCategoryName = payload.category.chinDisplayDesc
      state.info.portCategoryName = payload.category.portDisplayDesc
    }
    if (payload.categoryScale) {
      state.info.chinCategoryScaleName = payload.categoryScale.chinDisplayDesc
      state.info.portCategoryScaleName = payload.categoryScale.portDisplayDesc
    }
    state.info.chinSubunitEntityName = payload.subunitEntity.chinName
    state.info.portSubunitEntityName = payload.subunitEntity.portName
    state.info.chinVinculumTypeName = payload.vinculumType.chinDesc
    state.info.portVinculumTypeName = payload.vinculumType.portDesc
  }
}

export const { mapFields: mapCourseAppFormFields } = createHelpers({
  getterType: 'courseAppForm/getField',
  mutationType: 'courseAppForm/updateField'
})

export const courseAppForm = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
